import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '@/features/auth/auth-context'

export function RequireRole({ role }: { role: 'student' | 'admin' }) {
  const { profile } = useAuth()
  if (!profile) return <Navigate to="/login" replace />
  if (profile.user.role !== role) return <Navigate to={profile.user.role === 'admin' ? '/admin/dashboard' : '/home'} replace />
  return <Outlet />
}
